import script from "./DashboardHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardHistory.vue?vue&type=script&setup=true&lang=js"

import "./DashboardHistory.vue?vue&type=style&index=0&id=313ca4e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313ca4e3"]])

export default __exports__